import { CE } from './ce';

export class PB extends CE {}
